import {Domain} from "./Domain";

export const probeTypeDomain = new Domain([
  {value: 1, label: "Пищевые и непищевые продукты"},
  {value: 2, label: "Смывы/Пробы из внешней среды/Дез. средства"},
  {value: 3, label: "Вода/Почва"},
  {value: 4, label: "Замеры"},
  {value: 5, label: "КДИ"},
  {value: 6, label: "Нет проб"},
]);